//This for setting the value of the dropdown if RequireExplicitSelect is true
export const BLANK = 'blank';

//Bootstraps default animation time for .Collapse
export const COLLAPSE_TIME = 350;

//Smooth scroll time
export const SCROLL_TIME = 468;

//The sum of the height of the basket header and checkout button (to calculate the height for basket contents)
export const BASKET_OFFSET = 135;

//The minimum height that a basket can be
export const MIN_BASKET_HEIGHT = 91;

//Editing Blue color
export const EDITING_BLUE = '#2196f3';

//Limit for mobile mode
export const MOBILE_MODE_LIMIT = 992;
